import messages from '../../../locale/messages';
import { inputTextLimit, inputDescLimit } from '../../../helpers/inputTextLimit';

const validate = values => {
    const errors = {};
    if (values.title) {
        let homePageCategorySectionError = []
        if (values?.title?.map((item, index) => {
            const categorySectionError = {}
            if (!item?.title || item?.title.toString().trim() === '') {
                categorySectionError.title = messages.required;
                homePageCategorySectionError[index] = categorySectionError;
            } else if (item?.title?.length > inputTextLimit) {
                categorySectionError.title = messages.inputTextLimitError;
                homePageCategorySectionError[index] = categorySectionError;
            }

            if (!item?.description || item?.description.toString().trim() === '') {
                categorySectionError.description = messages.required;
                homePageCategorySectionError[index] = categorySectionError;
            } else if (item?.description?.length > inputDescLimit) {
                categorySectionError.description = messages.inputDescLimitError;
                homePageCategorySectionError[index] = categorySectionError;
            }

            if (!item?.language || item?.language.toString().trim() === '') {
                categorySectionError.language = messages.required;
                homePageCategorySectionError[index] = categorySectionError;
            }
        }));
        if (homePageCategorySectionError?.length > 0) errors.title = homePageCategorySectionError;
    }
    return errors;
};

export default validate;